
module dg.modals {

    export interface IModalOptions {
        //size?: string;
        //template?: string;
        windowClass?: string;
    }

    export class ModalService {

        public constructor(
            private $q: ng.IQService,
            private $uibModal: ng.ui.bootstrap.IModalService) {
        }

        public open(modalOptions: ng.ui.bootstrap.IModalSettings): ng.ui.bootstrap.IModalServiceInstance {
            let defaultModalOptions = {
                //size: 'lg',
                backdrop: 'static'
            };

            //var mergerModalOptions = _.mergeWith(modalOptions, this.defaultModalOptions, (value, defaultValue) => {
            //    return angular.isDefined(value) ? value : defaultValue;
            //});
            var mergerModalOptions = dgUtils.ObjectHelperService.mergeDeep(defaultModalOptions, modalOptions);
            return this.$uibModal.open(mergerModalOptions);
        }


        //public createLightboxModal(scope: dgComponents.list.IDgListMetaScope, modalOptions: IDgLightboxModalSettings, items: Array<any>) {
        //    return new DgLightboxModal(this.$q, this, scope, modalOptions, items);
        //}
    }
    angular.module('dg.modals')
        .service('modalService', ModalService);
}
